import { Trans } from "@lingui/react/macro";
import { useId } from "react";

import { useProPlanLabels } from "../../lib/useProPlanLabels";

// «Как оплатить»: автоплатёж через СБП или разовая оплата.
export const PaymentMethods = () => {
  const headingId = useId();
  const { price, period } = useProPlanLabels();
  return (
    <section aria-labelledby={headingId} className="flex flex-col gap-2.5">
      <h2 id={headingId} className="font-display text-[26px]">
        <Trans>How to pay</Trans>
      </h2>
      <ul className="grid grid-cols-[repeat(auto-fit,minmax(220px,1fr))] gap-3">
        <li className="flex flex-col gap-1 rounded-xl border border-border bg-surface px-4 py-3.5">
          <span className="font-semibold">
            <Trans>Autopay via SBP</Trans>
          </span>
          <span className="text-sm text-muted">
            <Trans>
              {price} every {period}. You can turn it off at any time.
            </Trans>
          </span>
        </li>
        <li className="flex flex-col gap-1 rounded-xl border border-border bg-surface px-4 py-3.5">
          <span className="font-semibold">
            <Trans>One-time payment</Trans>
          </span>
          <span className="text-sm text-muted">
            <Trans>SBP or bank card. Pro for {period}, without renewal.</Trans>
          </span>
        </li>
      </ul>
      <p className="text-sm text-subtle">
        <Trans>
          Pro turns on right after payment, in your account on relock.gg. Payments are accepted by
          the payment service Platega.
        </Trans>
      </p>
    </section>
  );
};
